import axios from 'axios';
import AppModel from 'Models/AppModel';
import { mutateEntity } from 'Root/store/components/commonMutations';
import { prepareOrder } from 'Root/helpers/client';

export default {
  state() {
    return {
      order: {},
      cachedOrders: [],
      ordersWithActivePro: [],
    };
  },

  mutations: {
    mutateEntity,

    updateOrdersWithActivePro(state, orders) {
      state.ordersWithActivePro = orders;
    },
  },

  actions: {
    async getOrder(store, orderId) {
      const { data } = await axios.get(`${AppModel.API_URI}/order/${orderId}`);

      if (data) {
        const preparedOrder = prepareOrder(data);
        store.commit('mutateEntity', { entity: 'order', data: preparedOrder });
      }
    },

    setOrdersWithActivePro({ commit }, orders) {
      commit('updateOrdersWithActivePro', orders);
    },
  },

  namespaced: true,
};
